import React from "react";

export function TestimonialsSection() {
  return (
    <div className="relative overflow-hidden bg-volt-carbon/50 py-24">
      <div className="absolute inset-0 bg-gradient-to-t from-volt-blue/5 to-transparent" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="inline-block text-3xl font-bold mb-4 bg-gradient-to-r from-volt-green via-volt-blue to-volt-green text-transparent bg-clip-text pb-2 border-b-2 border-volt-blue/20">
            Trusted by Creators
          </h2>
          <p className="text-gray-400 mt-4">
            See what our users are saying about Block Pattern Generator
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <blockquote className="bg-white/5 backdrop-blur-sm rounded-xl p-8 hover:bg-white/10 transition-all">
            <div className="flex items-center mb-6">
              <img
                src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150&h=150&q=80"
                alt="Sarah Johnson"
                className="w-12 h-12 rounded-full mr-4"
              />
              <div>
                <div className="font-medium text-white">Sarah Johnson</div>
                <div className="text-sm text-gray-400">Web Designer</div>
              </div>
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed">
              "Block Pattern Generator has completely transformed how I create
              WordPress layouts. The AI-powered generation saves me hours of
              work, and the patterns look absolutely professional."
            </p>
          </blockquote>

          <blockquote className="bg-white/5 backdrop-blur-sm rounded-xl p-8 hover:bg-white/10 transition-all">
            <div className="flex items-center mb-6">
              <img
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=150&h=150&q=80"
                alt="Mike Chen"
                className="w-12 h-12 rounded-full mr-4"
              />
              <div>
                <div className="font-medium text-white">Mike Chen</div>
                <div className="text-sm text-gray-400">WordPress Developer</div>
              </div>
            </div>
            <p className="text-gray-300 mb-4 leading-relaxed">
              "The quality of code generated is impressive. It's clean,
              efficient, and follows WordPress best practices perfectly. This
              tool has become an essential part of my development workflow."
            </p>
          </blockquote>
        </div>
      </div>
    </div>
  );
}
